import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  IconButton,
  Image,
  Spacer,
  Spinner,
  Tag,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import BottomDrawer from "../../components/BottomDrawer";
import {
  getMockMusicFestVenues,
  useMusicFestivalArtists,
  useMusicFestivalGigs,
  useMusicFestivalVenues,
} from "../../data/musicFestival.api";
import { Venue } from "../../types/MusicFestivalTypes";
import { MapPin } from "../../components/Map";
import { MapContext } from "../../context/map.context";
import { useNavigate } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";
import LocationButton from "../../components/LocationButton";

const AllVenues = () => {
  const navigate = useNavigate();

  const { setPins, flyTo, setVenues } = useContext(MapContext);
  const [eventPins, setEventPins] = useState<MapPin[]>([]);
  const [locations, setLocations] = useState<Venue[]>([]);

  const { data, loading } = useMusicFestivalVenues();
  const {data: hostData} = useMusicFestivalArtists();

  // const locations1: Venue[] = getMockMusicFestVenues // test data

  // stores locations data in a state and context store
  useEffect(() => {
    if (data && data.getEventLocations) {
      const fetchedLocations: Venue[] = data.getEventLocations;
      setLocations(fetchedLocations);
      setVenues(fetchedLocations);
    }
  }, [data]);

  // Moves map to lancaster town centre instead of university campus
  useEffect(() => {
    flyTo({
      pitch: 1,
      bearing: 1,
      zoom: 16,
      center: {
        lng: -2.803113,
        lat: 54.048958,
      },
    });
  }, [flyTo]);

  useEffect(() => {
    setVenues(locations);
    const pins = locations.map((venue) => {
      return {
        lng: venue.longitude,
        lat: venue.latitude,
        size: 25,
        onClick: () => navigate(`/musicfestival/${venue.id}`),
      };
    });
    setEventPins(pins);
  }, [locations, setVenues]);

  useEffect(() => {
    setPins([...eventPins]);
  }, [eventPins, setPins]);

  console.log(hostData)

  return (
    <>
      <BottomDrawer ml={"4em"} goBackUrl={`/`}>
        <IconButton
          aria-label={"Return to music festival home page button"}
          icon={<IoChevronBack />}
          zIndex={999}
          onClick={() => {
            navigate("/");
          }}
          position="absolute"
          top={2}
          right={"3.5em"}
        />
        <Box p={4}>
          <Flex mb={4} align="center">
            <Heading pr={"1rem"} size="md">
              List Of Venues
            </Heading>
            <LocationButton variant="outline"></LocationButton>
          </Flex>
          <VStack spacing={4}>
            {loading && <Spinner />}
            {locations
              .slice()
              .sort((a, b) => a.title.localeCompare(b.title))
              .map((location) => {
                return (
                  <HStack
                    align={"start"}
                    w={"100%"}
                    h={"5.5em"}
                    spacing={"1em"}
                    key={location.id}
                    onClick={() => {
                      navigate(`/musicfestival/${location.id}`);
                    }}
                  >
                    {location.imageUrl && (
                      <Image
                        style={{ aspectRatio: "1/1" }}
                        maxH={"100%"}
                        borderRadius={"xl"}
                        src={location.imageUrl}
                        alt="Image of music festival venue"
                      />
                    )}
                    <VStack
                      align={"start"}
                      justify={"start"}
                      h={"100%"}
                      spacing={0}
                    >
                      <Heading size={"sm"} mb={"0em"}>
                        {location.title}
                      </Heading>
                      <Spacer />
                      <Text>{location.description}</Text>
                      <Spacer />
                    </VStack>
                  </HStack>
                );
              })}
          </VStack>
        </Box>
      </BottomDrawer>
    </>
  );
};

export default AllVenues;
